export default "__VITE_ASSET__DJhgcW_p__"